import type { TExpenseFieldArrayName } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/expenses/types.ts';

export const EXPENSE_TABLE_HEADERS = [
  'Рядок фінансової звітності',
  'Складова витрат',
  'Сума, тис. од.',
  'Питома вага, %',
] as const;

export const EXPENSE_TABLE_COLUMN_WIDTHS = ['22%', '42%', '20%', '16%'] as const;

export const EXPENSE_TABLE_MIN_WIDTH = 820;

export const EXPENSE_GROUPS: Array<{ name: TExpenseFieldArrayName; title: string }> = [
  {
    name: 'expensesAnnual',
    title: '11.1. Розшифровка витрат рядків Форм №2 / №2-м / №2-мс за річною звітністю',
  },
  {
    name: 'expensesQuarterly',
    title: '11.2. Розшифровка витрат рядків Форми №2 за квартальною звітністю',
  },
  {
    name: 'expensesQuarterlySmall',
    title:
      '11.3. Розшифровка фінансових витрат та амортизації Форм №2-м / №2-мс за квартальною звітністю',
  },
];
